export function TimeOut(ms) {
    if (ms === void 0) { ms = 0; }
    return function (target, key, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setTimeout(function () { return originalMethod.apply(_this, args); }, ms);
        };
        return descriptor;
    };
}
//# sourceMappingURL=scroll-to-timeout.decorator.js.map


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/@nicky-lenaers/ngx-scroll-to/decorators/scroll-to-timeout.decorator.js
// module id = ../../../../@nicky-lenaers/ngx-scroll-to/decorators/scroll-to-timeout.decorator.js
// module chunks = vendor